module.exports = __webpack_public_path__ + "img/media (12).14f38a01.png";